const campaignFooterData = [
  {
    title: 'The State of Housing in America',
    content: 'map',
    body: 'Get answers to key housing questions with this interactive map',
    url: 'https://sponsorcontent.cnn.com/interactive/nar/map/',
    button: 'Explore Now'
  },
  {
    title: 'the long-term wealth-building benefits of home ownership',
    content: 'article1',
    body: '',
    url: 'https://sponsorcontent.cnn.com/interactive/nar/benefits-of-home-ownership/',
    button: 'Read Article'
  },
  {
    title: 'Space and Support:',
    content: 'article2',
    body: 'The key forces now driving where Americans move',
    url: 'https://sponsorcontent.cnn.com/interactive/nar/space-and-support/',
    button: 'Read Article'
  },
  {
    title: 'buying a home in 2022:',
    content: 'article3',
    body: 'How to navigate an ultracompetitive real estate market',
    url: 'https://sponsorcontent.cnn.com/interactive/nar/competitive-real-estate-market/',
    button: 'Read Article'
  },
  {
    title: 'Is buying a home still a good long-term investment?',
    content: 'video1',
    body: 'See what housing experts say',
    url: 'https://sponsorcontent.cnn.com/interactive/nar/benefits-of-home-ownership-video/',
    button: 'Watch Now'
  },
  {
    title: 'Where and why are people moving?',
    content: 'video2',
    body: 'Get expert answers',
    url: 'https://sponsorcontent.cnn.com/interactive/nar/space-and-support-video/',
    button: 'Watch Now'
  },
  {
    title: 'Where and what can I afford to buy?',
    content: 'video3',
    body: 'Experts break down complex housing questions',
    url: 'https://sponsorcontent.cnn.com/interactive/nar/competitive-real-estate-market-video/',
    button: 'Watch Now'
  }
];

export default campaignFooterData;
